import type { Connection } from "./stream.ts";

const offlineAfter = 15_000;

interface ConnectionDeps {
  readonly now: () => number;
  readonly after: (ms: number, run: () => void) => () => void;
  readonly opened: () => void;
  readonly backOnline: () => void;
  readonly changed: () => void;
}

export function createConnection(deps: ConnectionDeps) {
  let connection: Connection = { state: "conectando" };
  let offline = false;
  let offlineTimer: (() => void) | undefined;
  const set = (next: Connection): void => {
    const wasOffline = offline;
    if (next.state === "aberta" && connection.state !== "aberta") deps.opened();
    connection = next;
    offlineTimer?.();
    offlineTimer = undefined;
    if (next.state === "caida") {
      const wait = offlineAfter - (deps.now() - next.since);
      if (wait <= 0) offline = true;
      else offlineTimer = deps.after(wait, () => set(next));
    } else if (next.state === "aberta") offline = false;
    if (wasOffline && !offline) deps.backOnline();
    deps.changed();
  };
  return { set, members: { connection: () => connection, offline: () => offline } };
}
